'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UserService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = require('../../config');

var _user = require('./user.js');

var _module2 = require('./module.js');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../webComponents/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[UserService]');

var UserService = exports.UserService = function () {
    function UserService($filter, $rootScope, $injector, $q, sessionPrefix) {
        _classCallCheck(this, UserService);

        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.$injector = $injector;
        this.$q = $q;
        this.sessionKey = sessionPrefix ? sessionPrefix + '-login-result' : 'login-result';

        var loginResult = this.getLoginResult();
        if (loginResult) {
            this.currentUser = new _user.WinresUser(loginResult, $filter, $rootScope);
            this.broadcastUserDataChangedEvent();
        }
    }

    // ** REQUIRED BY PORTAL **


    _createClass(UserService, [{
        key: 'getCurrentUser',
        value: function getCurrentUser() {
            return this.currentUser;
        }

        // ** REQUIRED BY PORTAL **

    }, {
        key: 'login',
        value: function login(username, password, domain) {
            var _this = this;

            return this.makeRequestWithResponse('SignInWinresUser', {
                Number: username,
                Password: password,
                ConnectionName: domain,
                Key: _config.key
            }).then(function (response) {
                log('Login response:', response);
                if (response && !response.SessionID) {
                    log('No SessionID returned. Login to winres seemed to fail.');
                }
                return response && response.SessionID ? _this.loginWithData(response) : null;
            });
        }

        // Login with login data. This is called e.g. when resetting a password.

    }, {
        key: 'loginWithData',
        value: function loginWithData(data) {
            this.setLoginResult(data);
            this.currentUser = new _user.WinresUser(data, this.$filter, this.$rootScope);
            this.broadcastLoginEvent();
            this.broadcastUserDataChangedEvent();
            return this.currentUser;
        }
    }, {
        key: 'getLoginResult',
        value: function getLoginResult() {
            try {
                return JSON.parse(window.sessionStorage.getItem(this.sessionKey));
            } catch (e) {
                log.error("getLoginResult error: ", e);
                return null;
            }
        }
    }, {
        key: 'setLoginResult',
        value: function setLoginResult(value) {
            value.isSession = true;
            window.sessionStorage.setItem(this.sessionKey, JSON.stringify(value));
            log("Login result:", value);
        }

        // ** REQUIRED BY PORTAL **

    }, {
        key: 'logout',
        value: function logout(overrideDomain) {
            var winresCloudService = this.$injector.get('winresCloudService');
            winresCloudService.makeAuthenticatedRequest("SignOutWinresUser");
            window.sessionStorage.removeItem('login-result');
            window.sessionStorage.removeItem(this.sessionKey);

            var previousUser = this.currentUser;
            this.currentUser = null;

            this.$rootScope.$broadcast('logout', { previousUser: previousUser, overrideDomain: overrideDomain });
        }

        // ** REQUIRED BY PORTAL (if it is possible that user has multiple available
        // roles) **

    }, {
        key: 'switchRole',
        value: function switchRole(roleId) {
            var _this2 = this;

            if (this.currentUser.getCurrentRoleId() == roleId) {
                return this.$q(function (resolve) {
                    return resolve(_this2.currentUser);
                });
            }

            return this.makeAuthenticatedRequest("SelectUserRole", {
                UserRoleID: roleId
            }).then(function (loginResult) {
                if (loginResult == null) {
                    return null;
                }

                _this2.currentUser = new _user.WinresUser(loginResult, _this2.$filter, _this2.$rootScope);
                _this2.broadcastUserDataChangedEvent();
                return _this2.currentUser;
            });
        }

        // Required by the page 'salasana', i.e. if password change is possible.
        // NOTE: This triggers userDataChanged

    }, {
        key: 'changePassword',
        value: function changePassword(oldPassword, newPassword) {
            var _this3 = this;

            return this.makeAuthenticatedRequest('IntresChangePassword', {
                'OldPassword': oldPassword,
                'NewPassword': newPassword
            }).then(function (result) {
                if (result && result.SessionID) {
                    _this3.loginWithData(result);
                    return _this3.currentUser;
                } else {
                    return null;
                }
            });
        }
    }, {
        key: 'broadcastUserDataChangedEvent',
        value: function broadcastUserDataChangedEvent() {
            this.$rootScope.$broadcast('userDataChanged', this.currentUser);
        }
    }, {
        key: 'broadcastLoginEvent',
        value: function broadcastLoginEvent() {
            this.$rootScope.$broadcast('login', this.currentUser);
        }
    }, {
        key: 'makeRequest',
        value: function makeRequest(request, data) {
            var winresCloudService = this.$injector.get('winresCloudService');
            return winresCloudService.makeRequest(request, data);
        }
    }, {
        key: 'makeRequestWithResponse',
        value: function makeRequestWithResponse(request, data) {
            var winresCloudService = this.$injector.get('winresCloudService');
            return winresCloudService.makeRequestWithResponse(request, data);
        }
    }, {
        key: 'makeAuthenticatedRequest',
        value: function makeAuthenticatedRequest(request, data) {
            var winresCloudService = this.$injector.get('winresCloudService');
            return winresCloudService.makeAuthenticatedRequest(request, data);
        }
    }, {
        key: 'makeAuthenticatedRequestWithResponse',
        value: function makeAuthenticatedRequestWithResponse(request, data) {
            var winresCloudService = this.$injector.get('winresCloudService');
            return winresCloudService.makeAuthenticatedRequestWithResponse(request, data);
        }

        // ** REQUIRED BY PORTAL API ** - returns whether this environment supports
        // restoring password.

    }, {
        key: 'canRestorePassword',
        value: function canRestorePassword() {
            return true;
        }

        // ** PART OF PORTAL API (OPTIONAL) **
        //Requests a token to be mailed.

    }, {
        key: 'restorePassword',
        value: function restorePassword(email, connectionName) {
            return this.makeRequest('IntresRestorePassword', {
                Email: email,
                ConnectionName: connectionName
            });
        }

        // ** PART OF PORTAL API (OPTIONAL) **

    }, {
        key: 'doesTokenExist',
        value: function doesTokenExist(token) {
            return this.makeRequest('IntresRestorePasswordHasToken', {
                Token: token
            });
        }

        // ** PART OF PORTAL API (OPTIONAL) **

    }, {
        key: 'restorePasswordChange',
        value: function restorePasswordChange(token, password) {
            return this.makeRequest('IntresRestorePasswordChange', {
                Token: token,
                Password: password
            });
        }
    }, {
        key: 'checkPasswordToken',
        value: function checkPasswordToken(userID, token) {
            return this.makeRequestWithResponse('CheckPasswordToken', {
                UserID: userID,
                Token: token
            });
        }
    }, {
        key: 'setPasswordWithToken',
        value: function setPasswordWithToken(userID, token, password) {
            return this.makeRequestWithResponse('SetPasswordWithToken', {
                UserID: userID,
                Token: token,
                Password: password
            });
        }

        // Not part of Portal API.

    }, {
        key: 'changeEmailUsernameAndPassword',
        value: function changeEmailUsernameAndPassword(username, email, password) {
            var _this4 = this;

            return this.makeAuthenticatedRequest('IntresChangeEmailUsernameAndPassword', {
                Username: username,
                Email: email,
                Password: password
            }).then(function (response) {
                if (response && response.SessionID) {
                    _this4.loginWithData(response);
                    return _this4.currentUser;
                } else {
                    return null;
                }
            });;
        }
    }, {
        key: 'getPrivacyPolicy',
        value: function getPrivacyPolicy() {
            var user = this.getCurrentUser();
            if (user) {
                // log("Trying to get privacy policy... user.loginResult:", user.loginResult);
                if (user.loginResult.Office != null) {
                    // NOTE: PrivacyPolicyFi is hard coded now so it always return finnish field.
                    // Possibly because SignInWinresUser does not accept lang parameter
                    var language = this.$rootScope.language;
                    // log("Privacy policy language:", language);
                    if (language) {
                        var lang = language.charAt(0).toUpperCase() + language.slice(1).toLowerCase(); // capitalize.
                        var privacyPolicy = user.loginResult.Office.Settings['PrivacyPolicy' + lang];
                        if (privacyPolicy) return privacyPolicy;else return user.loginResult.Office.Settings.PrivacyPolicyEn;
                    } else if (user.loginResult.Office.Settings.PrivacyPolicyFi != null) return user.loginResult.Office.Settings.PrivacyPolicyFi;
                } else {
                    return false;
                }
            } else {
                return null;
            }
        }
    }, {
        key: 'getDestinationPrivacyPolicy',
        value: function getDestinationPrivacyPolicy(destCode, language) {
            return this.makeAuthenticatedRequest('GetDestinationPrivacyPolicy', {
                'DestCode': destCode,
                'Language': language
            });
        }
    }, {
        key: 'getBookingConditions',
        value: function getBookingConditions() {
            var user = this.getCurrentUser();

            if (user && user.loginResult.Office != null) {
                var language = this.$rootScope.language;

                if (language) {
                    var lang = _.capitalize(language);
                    var bookingConditions = user.loginResult.Office.Settings['BookingConditions' + lang];

                    if (bookingConditions) {
                        return bookingConditions;
                    } else {
                        // Use finnish booking conditions if booking condtions for current language are not found.
                        return user.loginResult.Office.Settings.BookingCondtionsFi;
                    }
                } else if (user.loginResult.Office.Settings.BookingConditionsFi != null) {
                    return user.loginResult.Office.Settings.BookingConditionsFi;
                }
            }

            return null;
        }
    }, {
        key: 'getAllowMarketing',
        value: function getAllowMarketing() {
            var user = this.getCurrentUser();
            if (user) {
                if (user.loginResult.Office !== null) {
                    return user.loginResult.Office.Settings.AllowMarketing;
                }
            } else {
                log.error("Tried to get allowmarketing setting. Loginresult does not seem to contain 'Office': loginResult:", user.loginResult);
                return null;
            }
        }
    }, {
        key: 'getAllowElectronicMarketing',
        value: function getAllowElectronicMarketing() {
            var user = this.getCurrentUser();
            if (user) {
                if (user.loginResult.Office !== null) {
                    return user.loginResult.Office.Settings.AllowElectronicMarketing;
                }
            } else {
                log.error("Tried to get AllowElectronicMarketing setting. Loginresult does not seem to contain 'Office': loginResult:", user.loginResult);
                return null;
            }
        }
    }, {
        key: 'getMarketingParams',
        value: function getMarketingParams() {
            var user = this.getCurrentUser();
            if (user) {
                if (user.loginResult.Office !== null) {
                    return user.loginResult.Office.Settings.Marketing;
                }
            } else {
                log.error("Tried to get Marketing setting. Loginresult does not seem to contain 'Office': loginResult:", user.loginResult);
                return null;
            }
        }
    }, {
        key: 'getElectronicMarketingParams',
        value: function getElectronicMarketingParams() {
            var user = this.getCurrentUser();
            if (user) {
                if (user.loginResult.Office !== null) {
                    return user.loginResult.Office.Settings.ElectronicMarketing;
                }
            } else {
                log.error("Tried to get ElectronicMarketing setting. Loginresult does not seem to contain 'Office': loginResult:", user.loginResult);
                return null;
            }
        }
    }, {
        key: 'getUserWhenAvailable',
        value: function getUserWhenAvailable() {
            var _this5 = this;

            var user = this.getCurrentUser();
            if (user) {
                return this.$q.resolve(user);
            } else {
                return this.$q(function (resolve) {
                    _this5.$rootScope.$on('login', function () {
                        resolve(_this5.getCurrentUser());
                    });
                });
            }
        }
    }]);

    return UserService;
}();

UserService.$inject = ['$filter', '$rootScope', '$injector', '$q', 'sessionPrefix'];
_module3.default.service('userService', UserService);


//////////////////
// WEBPACK FOOTER
// ./src/environment/winres/userService.js
// module id = 540
// module chunks = 2